import { ofType } from "redux-observable";
import { mergeMap, debounceTime } from "rxjs/operators";
import { merge, of } from "rxjs";

import { GET_LOGS } from "../types";
import {
  getLogsPending,
  getLogsFulfilled,
  getLogsRejected,
  setNoEntriesMessageLogs,
} from "../actions";
import { sendApiRequest, notifyError } from "../../../actions";
import generateError from "../../../utilities/generateError";
import { logsFiltersSelector } from "../selectors";
import { LOG_MESSAGES } from "../constants/logMessages";

const createPayload = (payload) => ({
  method: "get",
  url: "log/get",
  onSuccess: [
    (response) =>
      response.data.length === 0
        ? setNoEntriesMessageLogs(LOG_MESSAGES.NOT_FOUND)
        : getLogsFulfilled(response),
  ],
  onError: [getLogsRejected, (error) => notifyError(generateError(error))],
  data: payload,
});

const meta = {
  api: "ajaxApi",
};

const getLogsEpic$ = (action$, state$) =>
  action$.pipe(
    ofType(GET_LOGS.DEFAULT),
    debounceTime(500),
    mergeMap(({ payload }) => {
      const filters = logsFiltersSelector(state$.value);
      return merge(
        of(getLogsPending()),
        of(sendApiRequest(createPayload({ ...payload, ...filters }), meta))
      );
    })
  );

export default getLogsEpic$;



// WEBPACK FOOTER //
// ./src/features/log/epics/getLogsEpic.js